/**
 * Recursively flattens a hierarchical tree structure into a linear list of tree items
 * with their corresponding nesting level, including only items that are expanded.
 *
 * @template T - The type of tree item.
 * @param {T[]} treeItems - The list of root-level tree items to flatten.
 * @param {string[]} expandedItemIds - IDs of items that should be considered expanded.
 * @param {number} [level=0] - The current nesting level (used internally during recursion).
 * @returns {FlatTreeItem<T>[]} A flattened list of tree items with level metadata.
 */
export function flattenTreeItems(treeItems, expandedItemIds, level = 0) {
    const flatTreeItems = [];
    for (const item of treeItems) {
        const flatTreeItem = {
            item,
            level,
        };
        flatTreeItems.push(flatTreeItem);
        if (item.children && expandedItemIds.includes(item.id)) {
            flatTreeItems.push(...flattenTreeItems(item.children, expandedItemIds, level + 1));
        }
    }
    return flatTreeItems;
}
